import React from 'react';
import CTAButton from '../CTAButton';

const ServiceFinalCTA = ({ title, desc, p1, p2, onPrimaryClick, onSecondaryClick }) => {
    return (
        <section className="py-10 bg-white relative overflow-hidden">
            <div className="container mx-auto px-6 text-center relative z-10">
                <h2 className="text-3xl md:text-5xl font-bold text-[#01014C] syne mb-8 leading-tight">{title}</h2>
                <p className="text-[#01014C] max-w-2xl mx-auto mb-12 text-lg">{desc}</p>
                <div className="flex flex-wrap justify-center gap-6">
                    <CTAButton 
                        text={p1}
                        onClick={onPrimaryClick}
                        type="secondary"
                    />
                    <CTAButton 
                        text={p2}
                        onClick={onSecondaryClick}
                        type="outline-dark"
                    />
                </div>
            </div>
        </section>
    );
};
export default ServiceFinalCTA